var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.081,
    height: 15.081,
    viewBox: "0 0 15.081 15.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106814",
    "data-name": "Group 106814",
    transform: "translate(-6.807 -6.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49691",
    "data-name": "Path 49691",
    d: "M21.761,21.141l-3.427-3.426a6.606,6.606,0,1,0-.621.62L21.14,21.76a.439.439,0,1,0,.62-.62ZM9.354,17.419a5.7,5.7,0,1,1,4.033,1.67,5.666,5.666,0,0,1-4.033-1.67Z",
    fill: "#80838e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.c331b6d10edf00a9c4322fdac089c5eb.svg";
export { ForwardRef as ReactComponent };